// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rnpeeIvF587JBDe9JKpf{width:70%}`, "",{"version":3,"sources":["webpack://./src/app/catalog/product/pages/search.page/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,SAAA","sourcesContent":[".favorites-page-skeleton-title {\n  width: 70%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorites-page-skeleton-title": `rnpeeIvF587JBDe9JKpf`
};
export default ___CSS_LOADER_EXPORT___;
